import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { UI, DISPLAY } from '../styles/tl5';
import { ROUTES } from '../constants/routes';

// 404 — the hero from the reference's Error States page.
//
// This replaces a catch-all that redirected every unknown URL straight to
// the home page. That silently swallowed mistyped and dead links: the
// visitor landed somewhere they did not ask for with no explanation, and
// a broken link in an email or on a printed sheet looked like it worked.

const CTA = {
  borderRadius: '16px',
  p: '15px 22px',
  fontFamily: UI,
  fontSize: 16,
  fontWeight: 800,
  textDecoration: 'none',
};

const NotFound = () => (
  <Box component="main" sx={{ width: '100%', maxWidth: 1320, mx: 'auto', px: 2, pt: 2, pb: 9 }}>
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 2.5,
        p: 'clamp(32px, 6vw, 72px)',
        borderRadius: '36px',
        bgcolor: 'var(--tl-teal)',
        color: '#FFFFFF',
      }}
    >
      <Box
        component="span"
        sx={{ p: '6px 10px', borderRadius: '999px', bgcolor: 'var(--tl-yellow)', color: 'var(--tl-g9)', fontFamily: UI, fontSize: 12, fontWeight: 800 }}
      >
        Page not found · 404
      </Box>
      <Typography
        component="h1"
        sx={{
          m: 0,
          fontFamily: DISPLAY,
          fontWeight: 700,
          fontSize: 'clamp(36px, 7vw, 96px)',
          // The reference keeps its base 0.95 here, but at 96px the two
          // lines of this particular headline collide.
          lineHeight: 1.0,
          letterSpacing: '-.035em',
          textWrap: 'balance',
          color: '#FFFFFF',
        }}
      >
        This page took a different route.
      </Typography>
      <Typography sx={{ m: 0, fontFamily: UI, fontSize: 18, lineHeight: 1.55, color: '#E6FAF5', maxWidth: 560 }}>
        The link may be old or mistyped. Here are the most useful places to go next.
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Box component={Link} to={ROUTES.HOME} sx={{ ...CTA, bgcolor: 'var(--tl-yellow)', color: 'var(--tl-g9)' }}>
          Go to homepage
        </Box>
        <Box component={Link} to={ROUTES.TESTS} sx={{ ...CTA, bgcolor: 'var(--tl-g9)', color: '#FFFFFF' }}>
          Find a test
        </Box>
        <Box component={Link} to={ROUTES.REPORTS} sx={{ ...CTA, bgcolor: '#1E9580', color: '#FFFFFF' }}>
          My reports
        </Box>
      </Box>
    </Box>
  </Box>
);

export default NotFound;
